import * as z from "zod";
import { BomTemplateSummary } from "./bom-template-types";

export const listBomTemplates = {
  name: "listBomTemplates" as const,
  input: z.object({}),
  output: z.object({ templates: z.array(BomTemplateSummary) }),
};
